<div class="account-container flex flex-col items-center justify-center min-h-screen p-4">
    <!-- Tarjeta principal de Angular Material -->
    <mat-card class="account-card w-full max-w-lg p-8 rounded-2xl shadow-xl border-t-8 transform transition-transform duration-500 ease-in-out hover:scale-105">
      <mat-card-header class="flex flex-col items-center text-center mb-8">
        <mat-card-title class="account-title text-4xl font-extrabold mb-2">
          Bienvenido, {{ userEmail() }}
        </mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <p class="text-center text-gray-600 dark:text-gray-400 mb-10 max-w-prose mx-auto text-lg">
          ¡Bienvenido a la comunidad Camben! Te has registrado con éxito y ahora tienes acceso a todo lo que necesitas para comenzar a comprar.
          
          Explora nuestra tienda, gestiona tus pedidos y, sobre todo, no olvides **aprovechar tus cupones** para obtener descuentos especiales. ¡Tus próximos productos te están esperando!
        </p>
  
        <!-- Contenedor de los botones con diseño de cuadrícula -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <!-- Botón de Mi Tienda -->
          <a mat-flat-button
             routerLink="/product"
             class="w-full h-16 mat-elevation-z4 button-shop">
            <mat-icon>storefront</mat-icon>
            <span>Mi Tienda</span>
          </a>
  
          <!-- Botón de Mis Cupones -->
          <a mat-flat-button
             routerLink="/cupones"
             class="w-full h-16 mat-elevation-z4 button-coupon">
            <mat-icon>local_offer</mat-icon>
            <span>Mis Cupones</span>
          </a>
  
          <!-- Botón de Mis Pedidos -->
          <a mat-flat-button
             routerLink="/pedidos"
             class="w-full h-16 mat-elevation-z4 button-orders">
            <mat-icon>list_alt</mat-icon>
            <span>Mis Pedidos</span>
          </a>
  
          <!-- Botón de Cerrar Sesión -->
          <!--a mat-flat-button
             (click)="logout()"
             class="w-full h-16 mat-elevation-z4 button-logout">
            <mat-icon>logout</mat-icon>
            <span>Cerrar Sesión</span>
          </a-->
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  